import { Loader2 } from 'lucide-react'

export function LoadingRoute() {
  return (
    <div className="flex h-full min-h-96 flex-1 flex-col items-center justify-center">
      <Loader2 className="text-primary-50 h-20 w-20 animate-spin" />
    </div>
  )
}
